import { useQuery } from '@tanstack/react-query';
import { getMeUser } from '@/services/user';

export const useMeUser = () => {
  const { data: meUser, isLoading } = useQuery({
    queryKey: ['meUser'],
    queryFn: getMeUser,
  });

  return { meUser, isLoading };
};
